import { render, staticRenderFns } from "./CourseHelp.vue?vue&type=template&id=39b808c8&"
import script from "./CourseHelp.vue?vue&type=script&lang=js&"
export * from "./CourseHelp.vue?vue&type=script&lang=js&"
import style0 from "./CourseHelp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports